import { AlertTriangle, RotateCw } from 'lucide-react';

import { apiErrorMessage } from '@/lib/clients';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/** Ce qu'il faut d'un résultat de useQuery. */
export interface QueryLike { isError: boolean; error: unknown; refetch: () => unknown }

/**
 * Bannière d'échec de lecture : sans elle, un 403, un 500 ou une coupure réseau s'affichait comme une
 * liste vide ou « introuvable ». Le toast est émis une fois pour toutes par le QueryCache (main.tsx).
 */
export const QueryError = ({ query, className }: { query: QueryLike | QueryLike[]; className?: string }) => {
  const failed = [query].flat().filter((q) => q.isError);
  if (failed.length === 0) return null;
  return (
    <div role="alert" className={cn('flex items-center gap-3 rounded-lg border border-danger/30 bg-danger/10 p-3 text-sm text-danger', className)}>
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span className="flex-1">Erreur de chargement : {apiErrorMessage(failed[0]!.error, 'serveur injoignable')}</span>
      <Button size="sm" variant="outline" onClick={() => failed.forEach((q) => void q.refetch())}>
        <RotateCw className="h-4 w-4 mr-1" /> Réessayer
      </Button>
    </div>
  );
};
